const calculateLvlPercentage = (expPoints, initialExpPoints, lvlInterval) => {
    let percentage = Math.floor((expPoints - initialExpPoints) / (lvlInterval) * 100);
    return percentage;
}

export default calculateLvlPercentage